import { parse } from 'query-string'
import { useLocation } from 'react-router-dom'
import { useUseVenueQuery } from '../graphql'

function useVenue() {
  const { search } = useLocation()
  const { venueId } = parse(search)
  const skip = !venueId
  return useUseVenueQuery({
    variables: {
      id: String(venueId),
    },
    skip,
  })
}

export default useVenue
